module.exports = __webpack_public_path__ + "img/follow-us-4.a0856b1d.jpg";